/* eslint-disable react/prop-types */
import React from 'react';
import {
  shape, string, arrayOf, func,
} from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import withApplicationConfig from 'containers/withApplicationConfig';
import VerticalQuery from 'pages/Verticals';
import ProviderResultsPageQuery from 'pages/Verticals/ProviderResultsPage';
import ProviderProductPageQuery from 'pages/Verticals/ProviderProductPage';
import ErrorPageQuery from 'pages/ErrorPageQuery';
import StaticPage from 'pages/StaticPage/StaticPage';
import Unsubscribe from 'pages/Email/UnsubscribePage';
import Widget from 'components/affiliate/Widget';
import LandingPage from 'money101/overrides/pages/LandingPage/LandingPage';
import ForgotPasswordPage from 'components/auth/ForgotPasswordPage';
import { getRuntimeEnvVariables } from 'helpers/Utils';
import Loading from 'components/auth/Loading';
import Dashboard from 'components/dashboard/Dashboard';
import DashboardSettings from 'components/dashboard/DashboardSettings';
import DashboardProfile from 'components/dashboard/DashboardProfile';
import LoginLanding from 'pages/LoginLanding/LoginLanding';
import IframeLogin from 'components/auth/IframeLogin';
import EmailLanding from 'pages/EmailLanding/EmailLanding';

import TWCampaignPage from 'money101/overrides/pages/Campaign/TWCampaignPage';
import RewardPage from 'money101/overrides/pages/Reward/RewardPage';
import SummerTravelPage from 'money101/overrides/pages/Campaign/SummerTravelPage';

const REDIRECT_STATUS = 301;

const Routes = ({
  resultsPages, redirectLists, providers, ccResultsPageRoutes,
  log,
}) => (
  <Switch>
    {/* SCB landing page route */}
    {/* eslint-disable eqeqeq */}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_TW_SCB_LANDING_PAGE') == 'true' && <Route path="/Money速貸" exact render={props => <LandingPage {...props} provider="SCB" vertical="PL" />} />}
    <Route path="/聯盟行銷" exact render={props => <StaticPage {...props} route="聯盟行銷" />} />
    <Route path="/關於我們" exact render={props => <StaticPage {...props} route="關於我們" />} />
    <Route path="/媒體聯絡" exact render={props => <StaticPage {...props} route="媒體聯絡" />} />
    <Route path="/服務條款" exact render={props => <StaticPage {...props} route="服務條款" />} />
    <Route path="/隱私政策" exact render={props => <StaticPage {...props} route="隱私政策" />} />
    <Route path="/unsubscribe" exact component={Unsubscribe} />
    <Route path="/affiliate/widget/:hash" exact render={props => <Widget {...props} />} />
    <Route path="/會員註冊" exact render={props => <LoginLanding {...props} variant="grad01" hasStandaloneLoginPage={true} />} />
    <Route path="/edm" exact render={props => <EmailLanding {...props} />} />
    {/* Reward selection routes */}
    {/* eslint-disable eqeqeq */}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_REWARD_SELECTION') == 'true' && <Route path="/獎勵/兌換" exact render={props => <RewardPage {...props} />} />}

    {/* Summer Campaign route */}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_TW_SUMMER_CAMPAIGN') == 'true' && <Route path="/夏日旅行者聯盟" exact render={props => <SummerTravelPage {...props} />} />}
    {/* TW campaign routes */}
    {/* eslint-disable eqeqeq */}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_TW_CAMPAIGN_PAGE') == 'true' && <Route path="/活動/:vertical(信用卡|貸款)/:campaignName" exact render={props => <TWCampaignPage {...props} />} />}

    {/* Login/dashboard routes */}
    {/* eslint-disable eqeqeq */}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_LOGIN') == 'true' && <Route path="/忘記密碼" exact render={props => <ForgotPasswordPage {...props} hasStandaloneLoginPage={true} />} />}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_LOGIN') == 'true' && <Route path="/首頁" exact render={props => <Dashboard {...props} />} />}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_LOGIN') == 'true' && <Route path="/首頁/個人資料" exact render={props => <DashboardProfile {...props} />} />}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_LOGIN') == 'true' && <Route path="/首頁/設定" exact render={props => <DashboardSettings {...props} />} />}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_LOGIN') == 'true' && <Route path="/登入/讀取中" exact render={(props) => <Loading {...props} />} />}
    { getRuntimeEnvVariables('RUNTIME_ENABLE_LOGIN') == 'true' && <Route path="/iframe/login" exact render={(props) => <IframeLogin {...props} />} />}
    {/* eslint-enable eqeqeq */}
    {/* Redirect pages */}
    {
      redirectLists.map(({
        from,
        to,
        statusCode,
      }) => (
        <Route
          key={from}
          exact
          path={`${from}`}
          render={({
            staticContext,
            location,
          }) => {
            // eslint-disable-next-line no-param-reassign
            if (staticContext) staticContext.status = statusCode;
            return (
              <Redirect to={`${to}${location?.search}`} />
            );
          }
          }
        />
      ))
    }
    {/* Campaign pages */}

    {/* Providers Page Route */}
    <Route
      path="/:vertical?/銀行與合作機構"
      exact
      render={props => <ProviderResultsPageQuery {...props} />}
    />
    <Route
      path="/:vertical?/銀行與合作機構/:alias"
      exact
      render={props => <ProviderProductPageQuery {...props} />}
    />

    {/* Provider results page */}
    {Object.entries(resultsPages).map(([vertical, resultsPageConfig]) => (
      <Route
        key={`${vertical}-providers`}
        path={`/銀行與合作機構/:list/${vertical}`}
        exact
        render={props => (
          <VerticalQuery
            {...props}
            vertical={vertical}
            resultsPageConfig={resultsPageConfig}
          />
        )}
      />
    ))}

    {/* Result page with default list */}
    {Object.entries(resultsPages).map(([vertical, resultsPageConfig]) => (
      <Route
        key={`${vertical}-default-list`}
        exact
        path={`/${vertical}`}
        render={props => (
          <VerticalQuery
            {...props}
            vertical={vertical}
            resultsPageConfig={resultsPageConfig}
          />
        )}
      />
    ))}

    {Object.entries(resultsPages).map(([vertical, resultsPageConfig]) => (
      <Route
        key={`${vertical}-specified-list`}
        exact
        path={`/${vertical}/:list`}
        render={props => {
          const { location, staticContext } = props;

          /** Redirect for provider result page */
          const providerName = location?.pathname.split('/').splice('-1').join();
          if (providers.includes(providerName)) {
            if (staticContext) staticContext.status = REDIRECT_STATUS;
            const newURL = `/銀行與合作機構/${providerName}/${vertical}${location?.search}`;
            log && log('INFO', `redirect to ${newURL}`, REDIRECT_STATUS);

            return <Redirect to={newURL} />;
          }

          /* Result page with specified list */
          const isCCVertical = resultsPageConfig.enum === 'CC';
          if (isCCVertical && ccResultsPageRoutes.includes(location?.pathname)
            || !isCCVertical) {
            return (
              <VerticalQuery
                {...props}
                vertical={vertical}
                resultsPageConfig={resultsPageConfig}
              />
            );
          }

          /** Redirect for cc product page */
          if (staticContext) staticContext.status = REDIRECT_STATUS;
          const pathnameArray = location?.pathname.split('/');
          pathnameArray.splice(2, 0, '產品');
          const newURL = `${pathnameArray.join('/')}${location?.search}`;
          log && log('INFO', `redirect to ${newURL}`, REDIRECT_STATUS);

          return <Redirect to={newURL} />;
        }}
      />
    ))}

    {/* Product page */}
    {Object.entries(resultsPages).map(([vertical, resultsPageConfig]) => (
      <Route
        key={`${vertical}-product-page`}
        exact
        path={`/${vertical}/產品/:list`}
        render={props => (
          <VerticalQuery
            {...props}
            vertical={vertical}
            resultsPageConfig={resultsPageConfig}
            isResultsPageRoute={false}
          />
        )}
      />
    ))}

    <Route path="/**" render={props => <ErrorPageQuery {...props} errorCode={404} />} />
  </Switch>
);

Routes.propTypes = {
  cookies: shape({}),
  redirectLists: shape({}),
  resultsPages: shape({}),
  ccResultsPageRoutes: arrayOf(string).isRequired,
  providers: arrayOf(string).isRequired,
  log: func,
};

Routes.defaultProps = {
  cookies: null,
  redirectLists: shape({}),
  resultsPages: shape({}),
  log: null,
};

export default withApplicationConfig(Routes, ['languages', 'verticals', 'redirect', 'routes']);
